import React from 'react';
import clsx from 'clsx';
import styles from './DashboardGrid.module.css';

export interface DashboardGridProps {
  children: React.ReactNode;
  className?: string;
}

const DashboardGrid: React.FC<DashboardGridProps> = ({ children, className }) => {
  return <div className={clsx(styles.grid, className)}>{children}</div>;
};

export default DashboardGrid;
